import '../Components/birthday.css';
function HappyBirthday() {
    const queryString = window.location.search;
    var formattedName;
    var BirthdayCakeURL;
    const birthdayMessages = [
    {
        name: "WarmJoyful",
        message: "Wishing you a wonderful day filled with love, laughter, and joy."
    },
    {
        name: "SimpleSweet",
        message: "Hope your day is as amazing as you are."
    },
    {
        name: "ProfessionalPolite",
        message: "May this year bring you happiness and success."
    },
    {
        name: "CakeReminder",
        message: "Don’t forget to treat yourself to lots of cake today."
    },
    {
        name: "CheersAdventure",
        message: "Cheers to another year of adventures and memories."
    },
    {
        name: "FunLight",
        message: "Wishing you a day full of fun, laughter, and celebration!"
    },
    {
        name: "FunnyLevelUp",
        message: "You’re not getting older, you’re just leveling up!"
    },
    {
        name: "HealthHappiness",
        message: "May your year be filled with health, wealth, and happiness."
    },
    {
        name: "WarmWishes",
        message: "Sending you good vibes and warm wishes on your special day."
    },
    {
        name: "BrightFuture",
        message: "Hope today is just the start of a fantastic year ahead."
    }
    ];
    var birthdayMessage = birthdayMessages.at(0).message;
    try {
        const urlParams = new URLSearchParams(queryString);
        var BirthdayPersonName = "";
        var BirthdayGender = "Boy";
        BirthdayPersonName = urlParams.get('birthdayboy');
        if (BirthdayPersonName == null || BirthdayPersonName.length <= 0) {
            BirthdayPersonName = urlParams.get('birthdaygirl')
            BirthdayGender = "Girl";
        }
        if (BirthdayPersonName == null || BirthdayPersonName.length <= 0) {
            BirthdayPersonName = urlParams.get('birthdayperson')
            BirthdayGender = '';
        }
        if (typeof BirthdayPersonName != 'string') {
            throw new TypeError("Name is not a String");
        }
        BirthdayCakeURL = '/Birthday' + BirthdayGender + 'Cake.gif';
        formattedName = BirthdayPersonName;
        //const lowcasebirthdayperson = BirthdayPersonName.toLowerCase();
        // const birthdayNameWords = lowcasebirthdayperson.split(' ');
        
        // const FormattedNameWords = birthdayNameWords.map(word => {
        //     if (word.length === 0) {
        //         // Handle empty strings if present after splitting
        //         return ''; 
        //     }
        //     return word.charAt(0).toUpperCase() + word.slice(1);
        // });
        // formattedName = FormattedNameWords.join(' ');
        const MessageName = urlParams.get("birthdaymessage");
        if (typeof MessageName != 'string') {
            throw new TypeError("MessageName is not a String");
        }
        birthdayMessages.forEach(MessageValue => {
            if (MessageName === null) {
                birthdayMessage = birthdayMessages.at(0).message;
            }
            if (MessageValue.name === MessageName) {
                birthdayMessage = MessageValue.message;
            }
        });
    }
    catch (error) {
        formattedName = null;
        BirthdayCakeURL = '/BirthdayCake.gif';
        birthdayMessage = birthdayMessages.at(0).message;
    }

    return (
        <div className="CenterPage">
            <img src={BirthdayCakeURL} alt={"Birthday " + BirthdayGender + " Cake"} width={512}/>
            <h1>Happy Birthday{(formattedName == null || formattedName.length <= 0) ? '' : ' '  + formattedName}!</h1>
            <p>{birthdayMessage}</p>
        </div>
    );
}

export default HappyBirthday;